<script setup lang="ts">
import { mdiChevronUp } from "@mdi/js";
import NavIcon from "~/components/layout/Nav/NavIcon.vue";

interface Props {
	showRegionFlag?: boolean | undefined;
	regionLabel: string;
	defaultValue?: boolean;
	regionId?: string;
}

const props = defineProps<Props>();

const active = ref(true);
const contentVisible = ref(props.defaultValue ?? true);

const handleToggle = (active: boolean) => {
	if (!active) contentVisible.value = false;
};
</script>

<template>
	<UiAccordion
		@tab-open="
			() => {
				contentVisible = true;
				active = true;
			}
		"
		@tab-close="active = false"
		class="rounded-lg"
		:activeIndex="defaultValue ? 0 : 1"
	>
		<UiAccordionTab @toggleEnd="handleToggle">
			<template #header>
				<div
					:class="[
						'flex items-center w-full h-[32px] p-2 text-xs gap-1 font-bold rounded-t-lg bg-dark-800 dark:bg-dark-700 text-light-50 transition-all whitespace-nowrap flex-shrink-0',
						!active && 'rounded-lg',
					]"
				>
					<NavIcon
						v-if="regionId && showRegionFlag"
						:width="24"
						:height="24"
						:src="`/icons/regions-leagues-flags/${regionId.toLowerCase()}-circular.svg`"
						fallback="/icons/regions-leagues-flags/default-circular.svg"
						class="flex-shrink-0"
					/>
					<span :class="['overflow-hidden text-ellipsis']"> {{ regionLabel }} </span>
				</div>
			</template>
			<template #header-icon>
				<div class="absolute -translate-y-1/2 right-2 top-1/2">
					<UiIcon :class="['z-10 w-6 h-6 fill-light-50 transition-all', !active && 'rotate-180']" :path="mdiChevronUp" />
				</div>
			</template>
			<slot v-if="contentVisible" />
		</UiAccordionTab>
	</UiAccordion>
</template>
